import { useEffect, useState } from "react";
import Navigation from "../../utils/components/Navigation";
import DataTable from "../../utils/components/DataTable";
import { BsPlusCircle } from "react-icons/bs";
import CraneLogo from "../../static/Logo.svg";
import { Link } from "react-router-dom";
import { auth } from "../../App/routes";
import { useNavigate } from "react-router";
import { AiOutlineSearch } from "react-icons/ai";
import API from "../../utils/API";
import Loading from "../../utils/components/Loading";
import AddNewCompany from "./components/AddNewCompany";
import { useProject } from "../../utils/hooks/useProject";
import { useCan } from "../../utils/hooks/useCan";

// eslint-disable-next-line no-unused-vars
const PAGE_SIZE = 1000;
const SEARCH_TIMEOUT = 800;

const Companies = ({ translate, settings }) => {
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");
  const [searchedQuery, setSearchedQuery] = useState("");
  const [companies, setCompanies] = useState([]);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isClickable, setIsClickable] = useState(true);

  const navigate = useNavigate();

  const [modal, setModal] = useState(false);
  const [isCardView, setCardView] = useState(true);

  const { project } = useProject();

  const can = useCan();

  const [columns] = useState([
    {
      name: "#",
      selector: (row) => row.id,
      cell: (row) => (
        <img
          width="70px"
          src={row.logo || CraneLogo}
          alt={`${row.name} Logo`}
        />
      ),
      maxWidth: "90px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Users",
      selector: (row) => row.users,
      maxWidth: "250px",
    },
    {
      name: "Groups",
      selector: (row) => row.groups,
      maxWidth: "250px",
      style: {
        margin: "0 auto",
      },
    },
  ]);

  useEffect(() => {
    handleGetCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setIsLoading(true);

    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    if (query === searchedQuery) {
      setIsLoading(false);
      return;
    }

    setSearchTimeout(
      setTimeout(() => {
        setPage(1);
        setQuery(query);
      }, SEARCH_TIMEOUT)
    );
  };

  const handleGetCompanies = () => {
    API.getCompanies(project?.id, null, PAGE_SIZE, query).then(
      ({ data: res }) => {
        setSearchedQuery(query);
        setCompanies(page > 1 ? [...companies, ...res.data] : res.data);
        setIsLoading(false);
      }
    );
  };

  const refreshCompanies = () => {
    let forceGet = false;
    if (query === "" && page === 1) forceGet = true;

    setQuery("");
    setPage(1);

    if (forceGet) {
      handleGetCompanies();
    }
  };

  return (
    <div className="companies">
      {/* Dinamikleştirilecek alan */}
      <Navigation
        title={translate("page_titles.companies")}
        inputPlaceholder={translate("companies.filter_placeholder")}
        inputOnChange={handleSearch}
        iconNode={<AiOutlineSearch className="fs-5 me-2 mt-2" />}
        buttonNode={
          can.doThat("company:create") && (
            <p className="m-0 p-0 text-center">
              <BsPlusCircle className="fs-4 me-2" />
              {translate("companies.add_company")}
            </p>
          )
        }
        onButtonClick={
          can.doThat("company:create")
            ? () => {
                setIsClickable(true);
                setModal(true);
              }
            : false
        }
        onViewerClick={(view) => setCardView(view)}
      />
      {/* Dinamikleştirilecek alan */}
      {!isCardView &&
        (isLoading ? (
          <Loading classNames="mt-3" text={translate("loading") + `...`} />
        ) : (
          <DataTable
            highlightOnHover={true}
            pagination
            data={companies}
            columns={columns}
            onRowClicked={(row) =>
              can.doThat("company:update")
                ? navigate(auth.company.link.replace(":id", row.id))
                : false
            }
            pointerOnHover={Boolean(can.doThat("company:update"))}
          />
        ))}
      {isCardView &&
        (isLoading ? (
          <Loading classNames="mt-3" text={translate("loading") + `...`} />
        ) : (
          <div className="d-flex flex-wrap align-items-center">
            {companies.map((company) => (
              <CompanyCard
                key={company.id}
                company={company}
                translate={translate}
                can={can}
              />
            ))}
          </div>
        ))}
      <AddNewCompany
        show={modal}
        setShow={setModal}
        translate={translate}
        settings={settings}
        refreshCompanies={refreshCompanies}
        isClickable={isClickable}
        setIsClickable={setIsClickable}
      />
    </div>
  );
};

const CompanyCard = ({ company, translate, can }) => {
  return (
    <div className="company-card d-flex flex-column align-items-center shadow-sm border px-4 py-3 position-relative">
      <div className="d-flex justify-content-center align-items-center company-card-image-container">
        <img
          src={
            company.logo?.includes("/CompanyLogo") ? company.logo : CraneLogo
          }
          width="170px"
          alt={`${company.name} Logo`}
        />
      </div>
      <Link
        to={auth.company.link.replace(":id", company.id)}
        className="stretched-link"
        data-is-clickable={Boolean(can?.doThat("company:edit"))}
      >
        <p className="company-card-name">{company.name}</p>
      </Link>
      <div className="company-card-sub-group d-flex justify-content-around">
        <span className="d-flex flex-row flex-shrink-0">
          {translate("users")}: {company.users}
        </span>
        <span className="d-flex flex-row flex-shrink-0">
          {translate("groups")}: {company.groups}
        </span>
      </div>
    </div>
  );
};
export default Companies;
